const truthyValues = ['1', 'true', 'yes', 'on'];
const falsyValues = ['0', 'false', 'no', 'off'];

function envFlag(value, fallback) {
  if (value === undefined || value === null || value === '') {
    return fallback;
  }

  const normalized = String(value).toLowerCase();
  if (truthyValues.includes(normalized)) {
    return true;
  }
  if (falsyValues.includes(normalized)) {
    return false;
  }
  return fallback;
}

function envText(value, fallback) {
  return value === undefined || value === null || value === '' ? fallback : value;
}

const configuredThemeKey = envText(process.env.VUE_APP_SITE_THEME, '');
let activeThemeKey = configuredThemeKey;

export const promotionConfig = {
  enabled: envFlag(process.env.VUE_APP_PROMOTION_ENABLED, true),
  autoApply: true,
  visible: envFlag(process.env.VUE_APP_PROMOTION_ENABLED, true),
  code: envText(process.env.VUE_APP_PROMOTION_CODE, 'SUMMER20'),
  targetUrl: envText(process.env.VUE_APP_PROMOTION_TARGET_URL, '/residential/'),
  staticTargetUrl: envText(process.env.VUE_APP_PROMOTION_STATIC_TARGET_URL, '/staticisp/'),
  discountType: envText(process.env.VUE_APP_PROMOTION_DISCOUNT_TYPE, 'percent'),
  percentOff: Number(envText(process.env.VUE_APP_PROMOTION_PERCENT_OFF, '20')),
  amountOff: Number(envText(process.env.VUE_APP_PROMOTION_AMOUNT_OFF, '0')),
  amountCurrency: envText(process.env.VUE_APP_PROMOTION_AMOUNT_CURRENCY, 'usd'),
  startAt: envText(process.env.VUE_APP_PROMOTION_START_AT, ''),
  endAt: envText(process.env.VUE_APP_PROMOTION_END_AT, ''),
  eligibleTypes: ['1', '2'],
  agentTelegramUrl: envText(process.env.VUE_APP_AGENT_TELEGRAM_URL, 'https://t.me/+QTlIZobvM0wwMTZl'),
};

export const siteThemes = {
  default: {
    key: 'default',
    className: 'theme-default',
  },
  summer_2026: {
    key: 'summer_2026',
    className: 'theme-summer',
  },
};

export function getActiveTheme() {
  if (!activeThemeKey) {
    activeThemeKey = isPromotionEnabled() ? 'summer_2026' : 'default';
  }
  return siteThemes[activeThemeKey] || siteThemes.default;
}

export function isPromotionEnabled() {
  return Boolean(promotionConfig.enabled && promotionConfig.autoApply && promotionConfig.visible);
}

export function isPromotionEligibleType(type) {
  return isPromotionEnabled() && promotionConfig.eligibleTypes.includes(String(type));
}

export function setPromotionConfig(config = {}) {
  promotionConfig.enabled = Boolean(config.enabled);
  promotionConfig.autoApply = config.auto_apply === undefined ? Boolean(config.autoApply ?? true) : Boolean(config.auto_apply);
  promotionConfig.visible = config.visible === undefined ? promotionConfig.enabled && promotionConfig.autoApply : Boolean(config.visible);
  promotionConfig.code = envText(config.code, promotionConfig.code);
  promotionConfig.targetUrl = envText(config.target_url ?? config.targetUrl, promotionConfig.targetUrl);
  promotionConfig.staticTargetUrl = envText(config.static_target_url ?? config.staticTargetUrl, promotionConfig.staticTargetUrl);
  promotionConfig.discountType = envText(config.discount_type ?? config.discountType, promotionConfig.discountType);
  promotionConfig.percentOff = Number(config.percent_off ?? config.percentOff ?? promotionConfig.percentOff);
  promotionConfig.amountOff = Number(config.amount_off ?? config.amountOff ?? promotionConfig.amountOff);
  promotionConfig.amountCurrency = envText(config.amount_currency ?? config.amountCurrency, promotionConfig.amountCurrency);
  promotionConfig.eligibleTypes = Array.isArray(config.eligible_types) ? config.eligible_types.map(String) : promotionConfig.eligibleTypes;
  promotionConfig.agentTelegramUrl = envText(config.agent_telegram_url ?? config.agentTelegramUrl, promotionConfig.agentTelegramUrl);
  activeThemeKey = configuredThemeKey || (isPromotionEnabled() ? 'summer_2026' : 'default');
}

export function getPromotionDiscountLabel() {
  if (promotionConfig.discountType === 'amount' && Number(promotionConfig.amountOff) > 0) {
    const symbol = String(promotionConfig.amountCurrency).toLowerCase() === 'cny' ? '¥' : '$';
    const amount = Number(promotionConfig.amountOff);
    const text = Number.isInteger(amount) ? String(amount) : amount.toFixed(2);
    return `${symbol}${text} OFF`;
  }

  const percent = Number(promotionConfig.percentOff || 0);
  return Number.isInteger(percent) ? `${percent}% OFF` : `${percent.toFixed(2)}% OFF`;
}

export function calculatePromotionDiscount(total) {
  const amount = Number(total || 0);
  if (!Number.isFinite(amount) || amount <= 0 || !isPromotionEnabled()) {
    return 0;
  }

  if (promotionConfig.discountType === 'amount') {
    return Math.min(amount, Math.max(0, Number(promotionConfig.amountOff || 0)));
  }

  const percent = Math.max(0, Number(promotionConfig.percentOff || 0));
  return amount * percent / 100;
}

export function promotionText(vm, key) {
  return vm.$t(`activity.summer.${key}`, {
    discount: getPromotionDiscountLabel(),
    code: promotionConfig.code,
  });
}
